var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("iframe", {
      staticStyle: { border: "none" },
      attrs: {
        width: _vm.searchTableWidth,
        height: _vm.searchTableHeight,
        src: _vm.reportUrl,
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }